import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";
import { consentAtom } from "./atoms/consentAtom";
import isGoogleMapsLoadedAtom from "./atoms/maps/isGoogleMapsLoadedAtom";

import { GOOGLE_API } from "./store/utils";
import AppState from "./stories/components/AppState/AppState";

const LIBRARIES: Libraries = ["places"];

interface APILoader {
  googleMapsApiKey: string;
  preventGoogleFontsLoading: boolean;
  libraries: Libraries;
}

const apiLoader: APILoader = {
  googleMapsApiKey: GOOGLE_API,
  preventGoogleFontsLoading: false,
  libraries: LIBRARIES,
};

const App = () => {
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useAtom(
    isGoogleMapsLoadedAtom,
  );

  const { isLoaded, loadError } = useJsApiLoader(apiLoader);
  const hasConsent = useAtomValue(consentAtom);

  useEffect(() => {
    if (isLoaded && !isGoogleMapsLoaded) {
      setIsGoogleMapsLoaded(true);
    }
  }, [isLoaded, isGoogleMapsLoaded, setIsGoogleMapsLoaded]);

  useEffect(() => {
    if (loadError) {
      datadogLogs.logger.error("Error loading Google Maps API", loadError);
    }
  }, [loadError]);

  useEffect(() => {
    if (hasConsent) {
      datadogLogs.setTrackingConsent("granted");
      datadogRum.setTrackingConsent("granted");
      window.grantFBTracking();
      window.grantGTagTrackingA();
      window.grantGTagTrackingB();
    } else {
      datadogLogs.setTrackingConsent("not-granted");
      datadogRum.setTrackingConsent("not-granted");
      window.revokeFBTracking();
      window.revokeGTagTrackingA();
      window.revokeGTagTrackingB();
    }
  }, [hasConsent]);

  return <AppState />;
};

export default App;
